import { NavLinks } from '@iveco-ti/iveco-ds'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useNavigate } from 'react-router'

import { ROUTES } from '../constants/routes'

export function PanelLayout() {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const handleNavigate = (route: string) => {
    navigate(route)
  }

  return (
    <>
      <NavLinks.Root>
        <p className="text-lg text-brand-900 font-semibold mr-8">
          {t('panel_layout.title')}
        </p>

        <NavLinks.Link
          onClick={() => handleNavigate(ROUTES.PANEL.NEWS)}
          active={pathname === ROUTES.PANEL.NEWS}
        >
          {t('panel_layout.menus.news')}
        </NavLinks.Link>
      </NavLinks.Root>

      <Outlet />
    </>
  )
}
